/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RouterProvider } from 'react-router-dom';

import { router } from '@/routes/router';

export function App() {
  return <RouterProvider router={router} />;
}
